import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import WritersFilters from './components/WritersFilters';
import WritersTable from './components/WritersTable';
import { getWriters } from '../../../../../redux/settings/scout/scoutSettingsActions';
import { SCOUT_SETTINGS_FILTER } from '../../../../../constants';

import scss from './WritersList.module.scss';

const WritersList = () => {
  const dispatch = useDispatch();

  const tableSettings = useSelector((state) => state.scoutSettings.tableSettings);
  const tableFilters = useSelector((state) => state.scoutSettings.tableFilters);

  useEffect(() => {
    dispatch(getWriters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableSettings, tableFilters]);

  return (
    <div className={scss.pageWrapper}>
      <WritersFilters />

      {tableFilters.filterBy === SCOUT_SETTINGS_FILTER.WRITER ? <WritersTable /> : null}
    </div>
  );
};

export default WritersList;
